export const ensureApiArray = <T>(
  value: T[] | Record<string, T> | T | null | undefined,
): T[] => {
  if (value == null) return []
  if (Array.isArray(value)) return value
  if (typeof value === 'object') {
    return Object.values(value as Record<string, T>)
  }
  return [value]
}
